<template>
  <omint-page-content v-if="task">
    <template v-if="displayTerms">
      <div
        v-if="task.Optin"
        v-html="task.Optin"
      />
      <OmtButton
        mt="16px"
        mb="24px"
        w="100%"
        @click="hideTerms"
      >
        Fechar
      </OmtButton>
    </template>
    <template v-else>
      <OmtTypography as="h1-bold">Agendamento de consulta</OmtTypography>
      <CBox mt="16px">
        <OmtTypography
          color="var(--colors-light-primary-gray2)"
          as="p1"
        >
          {{ task.BeneficiarioBloqueado ? "Associado para atendimento" : "Beneficiário que realizará a consulta" }}
        </OmtTypography>
      </CBox>
      <OmtSelect
        mb="24px"
        :disabled="task.BeneficiarioBloqueado || isLoading"
        :isLoading="isLoading"
        :initialValue="selectedBeneficiary"
        :options="beneficiariosDisponiveis"
        placeholder="Selecione o associado"
        @change="onBeneficiarySelection($event)"
      />
      <OmtTypography
        color="var(--colors-light-primary-gray2)"
        as="p1"
      >
        {{ task.LocalBloqueado ? "Local para atendimento" : "Local para realizar a consulta" }}
      </OmtTypography>

      <OmtSelect
        mb="24px"
        :disabled="task.LocalBloqueado || isLoading"
        :isLoading="isLoading"
        :initialValue="`${selectedLocal}`"
        :options="locaisDisponiveis"
        placeholder="Selecione o local"
        @change="onLocalSelection($event)"
      />
      <p
        v-if="selectedAddress"
        class="selected-address"
      >
        {{ selectedAddress }}
      </p>

      <OmtTypography
        color="var(--colors-light-primary-gray2)"
        as="p1"
      >
        Especialidade para atendimento
      </OmtTypography>
      <OmtSelect
        mb="24px"
        :disabled="task.EspecialidadeBloqueada || isLoading"
        :isLoading="isLoading"
        :initialValue="`${selectedSpeciality}`"
        :options="especialidadesDisponiveis"
        placeholder="Selecione a especialidade"
        @change="onSpecialitySelection($event)"
      />

      <OmtTypography
        v-if="task.StaffBloqueado"
        color="var(--colors-light-primary-gray2)"
        as="p1"
      >
        Nome do profissional
      </OmtTypography>
      <OmtSelect
        v-if="task.StaffBloqueado"
        mb="24px"
        :isLoading="isLoading"
        :disabled="true"
        :options="staffsDisponiveis"
        :initialValue="`${selectedStaff}`"
        @change="onStaffSelection($event)"
      />

      <ConfirmationModal
        v-if="successMessegeProtocol"
        :protocol="successMessegeProtocol"
        title="Agendamento realizado com sucesso!"
        :avaliation="{ ticket: successMessegeProtocol, type: 8, step: 'S' }"
        detail-title="Seu agendamento está disponível na área “Minhas Atividades”"
        detail-description="Caso seja necessário cancelar ou reagendá-lo, clique em <strong>“Ver detalhes”</strong> e selecione a nova data para atendimento."
        @close="closeModal"
        @action="closeModal"
      />

      <v-calendar
        ref="calendar"
        v-chakra
        titlePosition="center"
        is-expanded
        border="none"
        class="schedule-calendar"
        mb="24px"
        :color="theme === 'dark' ? 'black' : 'indigo'"
        :is-dark="theme === 'dark'"
        :attributes="calendarAttributes"
        :available-dates="datasDisponiveis"
        @dayclick="onDayClick"
      />

      <template v-if="!isLoading && horariosDisponiveis.length > 0">
        <OmtTypography as="h2-bold"> Horários disponíveis </OmtTypography>
        <CBox
          display="grid"
          grid-template-columns="repeat(auto-fill, minmax(68px, 1fr))"
          grid-row-gap="16px"
          grid-column-gap="8px"
          justify-content="space-between"
          mt="16px"
          mb="24px"
        >
          <div
            v-for="time in horariosDisponiveis"
            :key="time"
            class="schedule__time-box"
            :class="{
              'schedule__time-box--selected': selectedTime === time
            }"
            @click="onTimeClick(time)"
          >
            {{ time }}
          </div>
        </CBox>
      </template>

      <CBox v-if="!isLoading && !task.StaffBloqueado && selectedTime">
        <OmtTypography
          color="var(--colors-light-primary-gray2)"
          as="p1"
        >
          Profissional para agendamento
        </OmtTypography>
      </CBox>
      <OmtSelect
        v-if="!isLoading && !task.StaffBloqueado && selectedTime"
        :disabled="isLoading"
        :isLoading="isLoading"
        :options="staffsDisponiveis"
        :initialValue="`${selectedStaff}`"
        mb="24px"
        placeholder="Selecione o profissional"
        @change="onStaffSelection($event)"
      />

      <CBox
        mb="32px"
        d="flex"
      >
        <OmtCheckbox
          :isDisabled="!this.selectedBeneficiary"
          @change="termsCheck = !termsCheck"
        />
        <OmtTypography
          class="schedule__term-box"
          as="p1"
        >
          <span @click="showTerms()">
            Li os <u>termos gerais (consentimento livre e esclarecido)</u>. Compreendi, concordo e aceito.
          </span>
        </OmtTypography>
      </CBox>

      <OmtButton
        w="100%"
        mb="24px"
        :isDisabled="disableButton"
        @click="onSubmit"
      >
        Agendar
      </OmtButton>
    </template>
  </omint-page-content>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { capitalize } from "@/utils/utils";
import ConfirmationModal from "@/components/Organisms/ConfirmationModal.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default {
  name: "Schedule",
  components: {
    ConfirmationModal
  },
  data() {
    return {
      chamado: 0,
      prestador: "",
      prevRoute: "",
      task: null,
      agenda: null,
      displayTerms: false,
      termsCheck: false,
      selectedBeneficiary: "",
      selectedLocal: "",
      selectedAddress: "",
      selectedSpeciality: "",
      selectedStaff: "",
      selectedDate: "",
      selectedTime: "",
      successMessegeProtocol: "",
      diaAgenda: null,
      horariosDisponiveis: [],
      isLoading: true,
      calendarAttributes: [
        {
          key: "selected-date",
          highlight: true,
          dates: null
        }
      ]
    };
  },
  computed: {
    ...mapGetters("saude", ["defaultRoute"]),
    ...mapState("saude", ["theme"]),
    isEquipeSaude() {
      return this.$route.name === "tasks.equipe";
    },
    isIndicacao() {
      return this.$route.name === "tasks.indicacao";
    },
    isPrestador() {
      return this.$route.name === "tasks.prestador";
    },
    beneficiariosDisponiveis() {
      if (!this.task?.Beneficiarios) return [];
      return this.task.Beneficiarios.map(l => ({
        value: l.Codigo,
        label: capitalize(l.Nome)
      }));
    },
    locaisDisponiveis() {
      if (!this.task?.Locais) return [];
      return this.task.Locais.map(l => ({
        value: l.Id,
        label: l.Nome
      }));
    },
    especialidadesDisponiveis() {
      if (!this.task?.Especialidades) return [];
      return this.task.Especialidades.map(l => ({
        value: l.Id,
        label: l.Nome
      }));
    },
    staffsDisponiveis() {
      if (!this.task?.Staffs) return [];
      if (this.task?.StaffBloqueado)
        return this.task.Staffs.map(s => ({
          value: s.Id,
          label: capitalize(s.Nome)
        }));

      const horario = this.diaAgenda?.Horarios?.find(h => h.Hora === this.selectedTime);
      if (!horario?.Staffs) return [];
      const staffsValidos = this.task.Staffs.filter(s => horario.Staffs.some(sh => sh.IdStaff === s.Id));
      const staffs = staffsValidos.map(s => ({
        value: s.Id,
        label: capitalize(s.Nome)
      }));
      return staffs;
    },
    datasDisponiveis() {
      if (!this.agenda || this.isLoading) return new Date(1, 0, 0);
      const dias = this.agenda.map(d => new Date(d.Ano, d.Mes - 1, d.Dia)) ?? [];
      return dias.length > 0 ? dias : new Date(1, 0, 0);
    },
    tipoOperacao() {
      if (this.isEquipeSaude) return 1;
      if (this.isIndicacao) return 2;
      if (this.isPrestador) return 3;
      return 0;
    },
    disableButton() {
      if (!this.termsCheck) return true;
      if (!this.selectedBeneficiary) return true;
      if (!this.selectedLocal) return true;
      if (!this.selectedSpeciality) return true;
      if (!this.selectedStaff) return true;
      if (!this.diaAgenda?.Dia) return true;
      if (!this.diaAgenda?.Mes) return true;
      if (!this.diaAgenda?.Ano) return true;
      if (!this.selectedTime) return true;
      return false;
    }
  },
  methods: {
    ...mapActions("tasks", ["featchTaskRules", "featchCalendar", "createTask"]),
    hideTerms() {
      this.displayTerms = false;
    },
    showTerms() {
      globalThis.window.scrollTo(0, 0);
      this.displayTerms = true;
    },
    async onBeneficiarySelection(value) {
      const alterarLoading = !this.isLoading;
      try {
        if (alterarLoading) this.isLoading = true;
        if (value && value !== this.selectedBeneficiary) {
          this.selectedBeneficiary = value;
          if (alterarLoading) {
            await this.iniciarRegras(value);
          }
        }
      } finally {
        if (alterarLoading) this.isLoading = false;
      }
    },
    async onLocalSelection(value) {
      const alterarLoading = !this.isLoading;
      try {
        if (alterarLoading) this.isLoading = true;
        value = Number(value);
        if (value && value !== this.selectedLocal) {
          const localObj = this.task.Locais.find(l => l.Id === value);
          this.selectedLocal = value;
          this.selectedAddress = localObj.Endereco;

          if (alterarLoading) await this.iniciarCalendario();
        }
      } finally {
        if (alterarLoading) this.isLoading = false;
      }
    },
    async onSpecialitySelection(value) {
      const alterarLoading = !this.isLoading;
      try {
        if (alterarLoading) this.isLoading = true;
        value = Number(value);
        if (value && value !== this.selectedSpeciality) {
          this.selectedSpeciality = value;
          if (alterarLoading) await this.iniciarCalendario();
        }
      } finally {
        if (alterarLoading) this.isLoading = false;
      }
    },
    async onStaffSelection(value) {
      const alterarLoading = !this.isLoading;
      try {
        if (alterarLoading) this.isLoading = true;
        value = Number(value);
        if (value && value !== this.selectedStaff) {
          this.selectedStaff = this.staffsDisponiveis?.find(s => s.value === value) ? value : "";
        }
        if (!this.selectedStaff && this.staffsDisponiveis?.length === 1) {
          this.selectedStaff = this.staffsDisponiveis[0].value;
        }
      } finally {
        if (alterarLoading) this.isLoading = false;
      }
    },
    async onDayClick(value) {
      const alterarLoading = !this.isLoading;
      try {
        if (alterarLoading) this.isLoading = true;
        if (value?.date && value.date !== this.selectedDate) {
          this.diaAgenda = this.agenda?.find(d => d.Dia === value.day && d.Mes === value.month && d.Ano === value.year);
          this.selectedDate = value.date;
          this.selectedTime = "";
          if (this.diaAgenda) {
            this.horariosDisponiveis = this.diaAgenda.Horarios?.map(h => h.Hora) ?? [];
            this.calendarAttributes[0].dates = value.date;
            if (this.horariosDisponiveis.length === 1) {
              await this.onTimeClick(this.horariosDisponiveis[0]);
            }
          }
          globalThis.window.scrollTo(0, document.body.scrollHeight);
        }
      } finally {
        if (alterarLoading) this.isLoading = false;
      }
    },
    async onTimeClick(value) {
      const alterarLoading = !this.isLoading;
      try {
        if (alterarLoading) this.isLoading = true;
        if (value && value !== this.selectedTime) {
          const currentStaff = this.selectedStaff;
          this.selectedTime = value;
          if (!this.task.StaffBloqueado) {
            this.selectedStaff = "";
            globalThis.window.scrollTo(0, document.body.scrollHeight);
            this.$nextTick(() => this.onStaffSelection(currentStaff));
          }
        }
      } finally {
        if (alterarLoading) this.isLoading = false;
      }
    },
    async iniciarCalendario() {
      const alterarLoading = !this.isLoading;
      try {
        if (alterarLoading) this.isLoading = true;
        if (this.selectedBeneficiary && this.selectedLocal && this.selectedSpeciality) {
          this.agenda = null;
          this.selectedDate = "";
          this.selectedTime = "";
          this.diaAgenda = null;
          this.horariosDisponiveis = [];
          this.calendarAttributes[0].dates = null;
          if (!this.task.StaffBloqueado) {
            this.selectedStaff = "";
          }
          const agenda = await this.featchCalendar({
            beneficiario: this.selectedBeneficiary,
            local: this.selectedLocal,
            especialidade: this.selectedSpeciality,
            staff: this.task.StaffBloqueado ? this.selectedStaff : 0
          });
          this.task.Staffs = agenda?.Staffs ?? [];
          this.agenda = agenda?.DiasDisponiveis ?? [];
          globalThis.window.scrollTo(0, document.body.scrollHeight);
        }
      } finally {
        if (alterarLoading) this.isLoading = false;
      }
    },
    async onSubmit() {
      if (this.disableButton) return;
      try {
        await this.$root.$emit("show-loading");
        const horario = this.diaAgenda?.Horarios?.find(h => h.Hora === this.selectedTime);
        const staff = horario.Staffs.find(sh => sh.IdStaff === this.selectedStaff);

        const chamadoGerado = await this.createTask({
          beneficiario: this.selectedBeneficiary,
          local: this.selectedLocal,
          especialidade: this.selectedSpeciality,
          staff: this.selectedStaff,
          dia: this.diaAgenda.Dia,
          mes: this.diaAgenda.Mes,
          ano: this.diaAgenda.Ano,
          hora: this.selectedTime,
          duracao: null,
          chamado: this.chamado,
          reserva: this.task.Reserva,
          slot: staff.Slot,
          tipo: this.tipoOperacao
        });
        if (chamadoGerado.MensagemProcessamento) {
          await this.$root.$emit("hide-loading");
          Swal.fire({
            icon: "error",
            text: chamadoGerado.MensagemProcessamento,
            confirmButtonText: "OK"
          });
        } else {
          await this.$root.$emit("hide-loading");
          this.successMessegeProtocol = chamadoGerado.ProtocoloANS;
        }
      } catch (error) {
        await this.$root.$emit("hide-loading");
        Swal.fire({
          icon: "error",
          text: "Serviço temporariamente indisponível",
          confirmButtonText: "OK"
        });
        globalThis.window.$log.error("Erro ao criar a tarefa", error);
      } finally {
        await this.$root.$emit("hide-loading");
      }
    },
    closeModal() {
      this.$root.$emit("show-loading");
      this.$router.push(this.defaultRoute);
    },
    resetScheduleSelection() {
      this.agenda = null;
      this.selectedDate = "";
      this.selectedTime = "";
      this.diaAgenda = null;
      this.horariosDisponiveis = [];
      this.calendarAttributes[0].dates = null;
    },
    isValidTask(task) {
      if (!task) return false;
      if (task.MensagemProcessamento) return false;
      if (!task.Beneficiarios?.length) return false;
      if (!task.Locais?.length) return false;
      if (!task.Especialidades?.length) return false;
      return true;
    },
    setTaskDefaults(task) {
      if (task.DiasDisponiveis?.length) {
        this.agenda = task.DiasDisponiveis;
        task.DiasDisponiveis = null;
      }
      this.task = task;
      if (task.StaffBloqueado) {
        if (task.Staffs?.length) this.onStaffSelection(task.Staffs[0].Id);
      } else {
        this.selectedStaff = "";
      }
      if (this.selectedSpeciality && !task.Especialidades.some(b => b.Id === this.selectedSpeciality)) {
        this.selectedSpeciality = "";
      }
    },
    selectOnlyAvailableOptions() {
      if (!this.selectedBeneficiary) {
        let beneficiario = this.task.Beneficiario;
        if (!this.task.Beneficiarios.some(b => b.Codigo === beneficiario)) {
          beneficiario = this.task.Beneficiarios[0].Codigo;
        }
        this.onBeneficiarySelection(beneficiario);
      }
      if (this.locaisDisponiveis?.length === 1) {
        this.onLocalSelection(this.locaisDisponiveis[0].value);
      }
      if (this.especialidadesDisponiveis?.length === 1) {
        this.onSpecialitySelection(this.especialidadesDisponiveis[0].value);
      }
    },
    async iniciarRegras(beneficiario) {
      if (this.isPrestador && !this.prestador) return false;
      let params = {
        chamado: this.chamado,
        prestador: this.prestador,
        tipo: this.tipoOperacao
      };

      if (beneficiario) params.vinculoBeneficiario = beneficiario;

      this.resetScheduleSelection();

      const task = await this.featchTaskRules(params);
      if (!this.isValidTask(task)) return false;
      this.setTaskDefaults(task);
      this.selectOnlyAvailableOptions();
      if (this.selectedBeneficiary && this.selectedLocal && this.selectedSpeciality) {
        if (!this.agenda?.length) await this.iniciarCalendario();
      }
      return true;
    },
    async initPage() {
      let regrasValidas = false;
      try {
        this.isLoading = true;
        this.prevRoute = this.$route.path;
        this.task = null;
        this.agenda = null;
        this.displayTerms = false;
        this.termsCheck = false;
        this.selectedBeneficiary = "";
        this.selectedLocal = "";
        this.selectedSpeciality = "";
        this.selectedStaff = "";
        this.selectedDate = "";
        this.selectedTime = "";
        this.diaAgenda = null;
        this.horariosDisponiveis = [];
        this.calendarAttributes = [
          {
            key: "selected-date",
            highlight: true,
            dates: null
          }
        ];

        regrasValidas = await this.iniciarRegras();
      } catch (error) {
        globalThis.window.$log.error("Erro ao carregar a tarefa", error);
      } finally {
        if (regrasValidas) {
          await this.$root.$emit("hide-loading");
          this.isLoading = false;
        } else {
          this.$router.push(this.defaultRoute);
        }
      }
    }
  },
  async mounted() {
    await this.$root.$emit("show-loading");
    this.chamado = this.$route.query.chamado ? Number(this.$route.query.chamado) : 0;
    this.prestador = this.$route.params.prestador ? this.$route.params.prestador : "";
    await this.initPage();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path;
      vm.chamado = to.query.chamado ? Number(to.query.chamado) : 0;
      vm.prestador = to.params.prestador ? to.params.prestador : "";
      vm.task = null;
    });
  },
  updated() {
    if (this.prevRoute !== this.$route.path) {
      this.$root.$emit("show-loading");
      this.$nextTick(() => this.initPage());
    }
  }
};
</script>

<style lang="scss">
.schedule-calendar {
  .vc-popover-content.direction-bottom.vc-nav-popover-container {
    background-color: var(--colors-light-primary-navy-blue);
  }
  .vc-highlight {
    background-color: var(--colors-light-primary-navy-blue) !important;
    border-radius: 3px !important;
  }
  .vc-day-content:focus {
    background-color: unset !important;
  }
  .vc-day-content.vc-focusable {
    border-radius: 3px;
  }
  .vc-day-content.vc-focusable.is-disabled {
    background-color: var(--colors-light-primary-light-gray) !important;
    pointer-events: none;
  }
  .vc-weekday {
    color: var(--colors-light-primary-navy-blue) !important;
    margin-top: 8px;
  }
}
</style>

<style scoped lang="scss">
.schedule__time-box {
  padding: 8px 16px;
  border: var(--colors-light-secondary-divider) 1px solid;
  border-radius: 40px;
  text-align: center;
  font-weight: 500;
  background-color: white;
  transition: background-color 500ms, border 500ms;
  user-select: none;
  cursor: pointer;
}

.schedule__time-box--selected {
  background-color: var(--colors-light-primary-navy-blue);
  border: var(--colors-light-primary-navy-blue) 1px solid;
  color: white;
}

.schedule__term-box {
  margin-left: 16px;
  cursor: pointer;
  user-select: none;
  u {
    font-weight: bold;
    color: var(--colors-light-primary-navy-blue);
  }
}

.selected-address {
  margin-left: 5px;
  margin-bottom: 16px;
}
</style>
